export default {
    title: 'Profile image',
    buttons: {
        choose: 'Update profile image',
        update: 'Save profile image',
        delete: 'Delete'
    },
    errors: {
        mimetype: 'Only JPG/PNG/GIF are allowed',
        size: 'The file size must not exceed 8MB'
    },
    success: {
        update: 'The profile picture was successfully updated',
        delete: 'The profile picture was successfully deleted'
    }
}
